import axios from "axios";
import { baseUrl } from "../constants";
import { getToken } from "firebase/messaging";
import { messaging } from "./firebase";

const { VITE_APP_VAPID_KEY } = import.meta.env;

async function generateFirebaseToken() {
  const accessToken = localStorage.getItem("accessToken");
  if (!accessToken) return;

  const permission = await Notification.requestPermission();
  if (permission !== "granted") {
    console.warn("❌ Notifications permission denied");
    return;
  }

  try {
    const token = await getToken(messaging, {
      vapidKey: VITE_APP_VAPID_KEY,
    });

    if (!token) {
      console.warn("⚠️ No Firebase token generated (maybe blocked or service worker missing)");
      return;
    }

    // Optionally: compare with token already saved in localStorage
    const savedToken = localStorage.getItem("firebaseWebToken");

    if (token !== savedToken) {
      // 🔄 Send only if token changed
      console.log("📬 Sending new token to backend:", token);

      await axios.post(
        `${baseUrl}/user-firebase-token`,
        { webToken: token },
        { headers: { Authorization: `Bearer ${accessToken}` } }
      );

      // ✅ Save locally
      localStorage.setItem("firebaseWebToken", token);
    } else {
      console.log("✅ Token unchanged, no need to update");
    }
  } catch (error) {
    console.error("🔥 Error generating Firebase token:", error);
  }
}

export default generateFirebaseToken;
